import { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Location from '@solvhealth/types/interfaces/Location';
import AuthenticationContext from '~/core/login/AuthenticationContext';
import { PaperworkState } from '~/ducks/paperwork';
import { PaperworkSagas } from '~/sagas/paperwork';
import { useAccountMatchesBooking } from './useAccountMatchesBooking';
import { useAutofillPaperwork } from './useAutofillPaperwork';
import { useInitializeAddressValidation } from './useInitializeAddressValidation';

export const useInitializePaperworkData = (
  paperwork: PaperworkState,
  bookingId: string,
  location: Location
) => {
  const [isInitializingPaperworkData, setIsInitializingPaperworkData] = useState(false);
  const dispatch = useDispatch();
  const { isLoggedIn } = useContext(AuthenticationContext);
  const doesAccountMatchBooking = useAccountMatchesBooking();
  const isLoggedInAndMatchesBooking = isLoggedIn && doesAccountMatchBooking;
  useInitializeAddressValidation();

  useAutofillPaperwork(bookingId);

  useEffect(() => {
    if (!paperwork?.standardFields && !isInitializingPaperworkData && bookingId) {
      setIsInitializingPaperworkData(true);
      dispatch({
        type: PaperworkSagas.INITIALIZE_PAPERWORK_DATA,
        bookingId,
        location,
        usePublicData: !isLoggedInAndMatchesBooking,
      });
    }
  }, [
    bookingId,
    location,
    isInitializingPaperworkData,
    paperwork,
    setIsInitializingPaperworkData,
    isLoggedInAndMatchesBooking,
    dispatch,
  ]);
};
